import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'contexts/PostHogContext';

const PostHogPageviewTracker = () => {
  const location = useLocation();
  const { captureEvent, isLoaded } = usePostHog();

  useEffect(() => {
    // Only capture pageview if PostHog is loaded
    // If not loaded, the event will be queued automatically by captureEvent
    captureEvent('$pageview');
  }, [location, captureEvent]);

  return null;
};

export default PostHogPageviewTracker;
